"use client";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";

import { useStore, observer } from "../../service/mobx";
import { entityMap } from "../../component/Search/Hooks";
import { menuOptionsPublisher } from "../../component/Menu/menus/Search/Publisher";
import { menuOptionsTime } from "../../component/Menu/menus/Search/Time";
import { menuOptionsSort } from "../../component/Menu/menus/Search/Sort";

function HooksSearch() {
  const [firstLoad, setFirstLoad] = useState(true);
  const { analytics, search, tasks } = useStore();
  const searchParams = useSearchParams();

  useEffect(() => {
    // set context
    analytics.set.context("Search", "View");
    // reset context when component unmounts
    return () => {
      search.reset();
      analytics.set.context();
    };
  }, [analytics, search]);

  useEffect(() => {
    search.set.searchParams(searchParams);
  }, [search, searchParams]);

  const paramQ = searchParams.get("q") || undefined;

  useEffect(() => {
    search.set.userInput(paramQ);
  }, [search, paramQ]);

  const paramTime = searchParams.get("time") || undefined;

  useEffect(() => {
    const time = extractValue(paramTime, menuOptionsTime);

    search.set.filterTime(time);
  }, [search, paramTime]);

  const paramStars = searchParams.get("stars") || undefined;

  useEffect(() => {
    search.set.filterStars(paramStars);
  }, [search, paramStars]);

  const paramType = searchParams.get("type") || undefined;

  useEffect(() => {
    const type = extractValue(paramType, entityMap);

    search.set.filterType(type);
  }, [search, paramType]);

  const paramSort = searchParams.get("sort") || undefined;

  useEffect(() => {
    const sort = extractValue(paramSort, menuOptionsSort);

    search.set.filterSort(sort);
  }, [search, paramSort]);

  const paramPublisher = searchParams.get("publisher") || undefined;

  useEffect(() => {
    const publisher = extractValue(paramPublisher, menuOptionsPublisher);

    search.set.filterPublisher(publisher);
  }, [search, paramPublisher]);

  const paramTask = searchParams.getAll("task");

  useEffect(() => {
    if (tasks._set.size) {
      const taskSet = new Set(paramTask.filter(task => tasks._set.has(task)));

      search.set.filterTask(taskSet);
    }
  }, [search, tasks._set, paramTask]);

  const notLoadingSearchResultsFirst =
    firstLoad && searchParams.has("type") === false;

  useEffect(() => {
    if (notLoadingSearchResultsFirst) {
      search.set.loadingResults(false);
    }

    setFirstLoad(false);
  }, [search, notLoadingSearchResultsFirst]);
}

export default observer(HooksSearch);

function extractValue(urlValue, obj) {
  const value = urlValue?.toLowerCase();

  if (value) {
    const acceptedValues = new Set(Object.keys(obj));

    return acceptedValues.has(value) ? value : undefined;
  }
}

export function SetTrendingHook({ trending }) {
  const { search } = useStore();
  const isTrendingPage = useSearchParams().size === 0;

  useEffect(() => {
    if (isTrendingPage) {
      const { papers, tasks, videos } = trending;

      search.set.suggestedPapers(papers);
      search.set.suggestedTasks(tasks);
      search.set.suggestedVideos(videos);
    }
  }, [search, trending, isTrendingPage]);
}
